/*
article-list
show hides article-list__hamburger on scrolling
show hides article-list__list on button click

IMPORTANT!
Some things are very similar to scrollToTop.js

https://www.gww-netz.de/de/produktion-dienstleistung/vorteile.html

tobias.wolf@wagnerwagner.de
*/

function ArticleList() {
  // elements
  const element = document.querySelector('.article-list');
  const containerElement = document.querySelector('.article-list__container');
  const hamburgerElement = document.querySelector('.article-list__hamburger'); // button element
  const listElement = document.querySelector('.article-list__list'); // button element

  // functions
  function init() {
    setHeightOfContainer();
  }
  function setHeightOfContainer() {
    if (!element.classList.contains('article-list_fixed')) {
      element.style.height = `${element.offsetHeight}px`;
    }
  }
  function hide() {
    if (element) {
      element.classList.remove('is-visible');
    }
  }
  function show() {
    if (element) {
      element.classList.add('is-visible');
    }
  }
  function handleScroll() {
    // like scrollToTop.js
    const scrollTop = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    let toggleTop = 400;
    if (document.querySelector('.mod_article:nth-child(2)')) {
      // 64 is margin-bottom of .text-teaser
      toggleTop = document.querySelector('.mod_article:nth-child(2)').offsetTop - 64;
    }
    if (scrollTop >= toggleTop) {
      // Scroll 64 Pixel for full opacity
      let opacity = (scrollTop - toggleTop) / 64;
      opacity = opacity > 1 ? 1 : opacity;
      element.classList.add('article-list_fixed');
      containerElement.style.opacity = opacity;
      listElement.style.transitionDuration = '0s';
      setTimeout(() => {
        listElement.style.transitionDuration = null;
      }, 10);
    } else {
      element.classList.remove('article-list_fixed');
      containerElement.style.opacity = null;
    }
  }
  function handleClick() {
    if (element.classList.contains('is-visible')) {
      hide();
    } else {
      show();
    }
  }
  function handleResize() {
    setHeightOfContainer();
  }

  // event listeners
  if (element) {
    document.addEventListener('scroll', handleScroll);
    hamburgerElement.addEventListener('click', handleClick);
    window.addEventListener('resize', handleResize);
  }

  // init
  if (element) {
    init();
  }

  // public variables
  this.hide = hide;
}


window.ARTICLE_LIST = new ArticleList();
